<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2025 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container *ngIf="!storageType">
    <scrm-label labelKey="LBL_FIELD_STORAGE_NOT_SET"></scrm-label>
</ng-container>

<ng-container *ngIf="storageType && !isValidStorageType">
    <scrm-label labelKey="LBL_FIELD_STORAGE_INVALID_TYPE"></scrm-label>
</ng-container>

<div *ngIf="storageType && isValidStorageType" class="attachments attachments-edit-mode" (dragover)="displayUploadArea.set(true)"
     (dragleave)="displayUploadArea.set(false)" #wrapper>

    <scrm-dropdown-button [class.d-none]="displayUploadArea()" #dropdownButtonComponent [config]="dropdownButton"></scrm-dropdown-button>

    <div [class.d-none]="displayUploadArea() || !uploadedFiles()" class="uploaded-files">
        <scrm-multiple-uploaded-files class="d-flex flex-column"
                                      [files]="uploadedFiles()"
                                      [breakpoint]="breakpoint"
                                      [chunks]="chunks"
                                      [popoverLinkPosition]="popoverLinkPosition"
                                      [wrapper]="wrapper"
                                      [popoverMaxTextLength]="popoverMaxTextLength"
                                      [popoverMinWidth]="popoverMinWidth"
                                      [compact]="compact"
                                      [maxTextWidth]="maxTextWidth"
                                      [minWidth]="minWidth"
                                      (clear)="clearFile($event)"
        ></scrm-multiple-uploaded-files>
    </div>


    <scrm-file-upload-area #uploadArea
                           [class.d-flex]="displayUploadArea()"
                           [class.flex-grow-1]="displayUploadArea()"
                           [class.d-none]="!displayUploadArea()"
                           [uploadLabel]="'LBL_EMAIL_ATTACHMENT'"
                           [uploadDescription]="'LBL_ATTACHMENTS_FIELD_UPLOAD_BUTTON_DESCRIPTION'"
                           (onFileAdd)="onFileAdd($event)"
                           [allowMultiple]="true"
    >
    </scrm-file-upload-area>
</div>
